module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-22.14d000b7.png";